<template>
    <transition name="fade">
        <div class="select-size-validation">
            {{message || 'Select a value'}}
        </div>
    </transition>
</template>

<script>
    export default{
        props: ['message']
    }
</script>